import { EntityState, createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { Application } from '../models';
import { applicationActions } from '../actions';
import { DASHBOARD_APP_NAME } from '../constants';

export const applicationAdapter: EntityAdapter<Application> = createEntityAdapter<Application>({
  selectId: (item: Application) => item.id,
  sortComparer: sortApplicationsByNameWithHomeFirst,
});

export interface State extends EntityState<Application> {
  loading: boolean;
  loaded: boolean;
}

export const INIT_STATE: State = applicationAdapter.getInitialState({
  loading: false,
  loaded: false,
});

export function sortApplicationsByNameWithHomeFirst(a: Application, b: Application): number {
  if (a.name === DASHBOARD_APP_NAME) {
    return -1;
  }
  if (b.name === DASHBOARD_APP_NAME) {
    return 1;
  }
  return a.name.localeCompare(b.name);
}

export function reducer(state = INIT_STATE, action: applicationActions.All) {
  switch (action.type) {
    case applicationActions.LOAD: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case applicationActions.LOAD_SUCCESS: {
      return {
        ...applicationAdapter.addMany(setDefaultImages(action.payload) as Application[], state),
        loading: false,
        loaded: true,
      };
    }
    case applicationActions.UPDATE_SUCCESS: {
      return applicationAdapter.updateOne(
        {
          id: action.payload.id,
          changes: setDefaultImage(action.payload),
        },
        state
      );
    }
    case applicationActions.LOAD_BY_ID_SUCCESS:
    case applicationActions.CREATE_SUCCESS: {
      return applicationAdapter.addOne(setDefaultImage(action.payload), state);
    }
    case applicationActions.DELETE_SUCCESS: {
      return applicationAdapter.removeOne(action.payload, state);
    }
    case applicationActions.LOAD_BY_ID_FAILED:
    case applicationActions.LOAD_FAILED: {
      return { ...state, loading: false, loaded: false };
    }
    case applicationActions.CREATE_FAILED:
    case applicationActions.DELETE_FAILED:
    case applicationActions.UPDATE_FAILED: {
      return { ...state, loading: false };
    }
    default: {
      return state;
    }
  }
}
export const getApplicationsLoading: (State) => boolean = (state: State) => state.loading;
export const getApplicationsLoaded: (State) => boolean = (state: State) => state.loaded;

export function setDefaultImage(app: Application): Application {
  if (!app.imgUrl) {
    app.imgUrl = '/assets/dashboard-icon.png';
  }
  return app;
}

export function setDefaultImages(apps: Application[]): Application[] {
  return apps.map((app) => setDefaultImage(app));
}
